// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content054_wrapper__LQArj","block":"Content054_block__2rgBR","image":"Content054_image__uM68f"};